import { render } from "./HeaderLogo.vue?vue&type=template&id=3b035d4a&ts=true"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__